import React from 'react'

function Index() {
  return (
    <div className='mt-20 lg:mt-40 pt-10 mb-60 flex flex-col center'>
      <div className='w-[80%] flex flex-col'>
        {/* <h1 className='text-white tex-regular text-7xl'>SHERBIMET <span className='text-transparent'>f</span>
          <span className='main-red-color'>TONA</span></h1> */}
        <div className="w-full flex-col lg:flex-row flex items-end">
          <p className='text-white mt-5 montserrat font-light text-4xl lg:text-5xl w-[100%] lg:w-[55%] '>
           <b className='font-medium main-red-color'>400+</b> NJESI BANESORE
            <br />  <b className="font-medium main-red-color">7050 m2</b> ZONA AFARISTE 
           <br /> <b className='font-medium main-red-color'>10K+ m2</b> HAPESIRA TE GJELBERUARA
            
          </p>
          <div className='w-[50%] flex center mt-5 lg:mt-0'>
            <img className='w-[30%]' src="/images/logo.png" alt="" />

          </div>
        </div>
      </div>

      <br />

      <br />
      <br />
      <hr />
{/* 
      <div className='w-[80%] lg:w-full grid grid-cols-12 lg:mt-40'>
        <div className="col-span-12 order-1 lg:order-1 lg:col-span-3 fle flex-col lg:pl-5">
          <h1 className='lg:hidden lg:absolute  top-0 montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-9xl'>01. </h1>

          <h1 className='text-white tex-regular mt-5 lg:mt-0 text-5xl lg:text-8xl '>AKSES <span className='w-[10px]'></span> TE <br /> <span className='main-red-color'>SIGURT</span></h1>
        </div>

        <div className="col-span-12 order-3 lg:order-2 lg:col-span-6 flex center ">
          <img className='mt-5 lg:mt-0 w-full lg:w-[80%] lg:h-[90vh] object-cover rounded-[5px]' src="/images/services/smart-elevator.png" alt="" />
        </div>
        <div className="col-span-12 order-2 lg:order-3 lg:col-span-3 h-full flex justify-end items-end relative">
          <h1 className='hidden lg:absolute  top-0 montserrat text-white left-5 opacity-50 font-extralight text-9xl'>01. </h1>
          <p className='text-white montserrat text-base lg:text-xl mt-5 lg:mt-0  '>
            Vetem banoret dhe te ftuarit e tyre kane akses ne rezidenca, nderkohe qe katet per sherbime tregtare
            kane hymje te ndara.
          </p>
        </div>
      </div> */}

      <div className='w-[80%] mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='lg:pr-10 w-full lg:w-[90%] flex flex-col items-start lg:items-end'>
              <h1 className=' montserrat text-white  opacity-50 font-extralight text-4xl lg:text-7xl'>01. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5  text-left lg:text-right'>AKSES TE
                <br />
                <span className='main-red-color'>SIGURT</span></h1>
              <p className='text-white montserrat text-base lg:text-xl  mt-5 lg:text-right'>
                Vetem banoret dhe te ftuarit e tyre kane akses ne rezidenca, nderkohe qe katet per sherbime tregtare
                kane hymje te ndara.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <img src="/images/services/smart-elevator.png" className='lg:h-[80vh] object-cover rounded-[10px]' alt="" />
          </div>
        </div>
      </div>

      <div className='w-[80%] mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 order-2 lg:order-1 lg:col-span-7">
            <img src="/images/services/community.png" className='lg:h-[80vh] object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5 order-1 lg:order-2   flex flex-col relative">
            <div className='w-full lg:w-[80%]'>
              <h1 className='lg:pl-10 montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>02. </h1>
              <h1 className='lg:pl-10 text-white tex-regular text-5xl lg:text-7xl mt-5'>KOMUNITET
                <br />
                <span className='main-red-color'>FRYMZUES</span></h1>
              <p className='text-white montserrat lg:pl-10 text-base lg:text-xl  '>
                Ne HIT IMPERIAL, cdo banor gezon jo vetem nje shtepi te rehatshme por edhe hapesira te dedikuara
                per socializim, mireqenie dhe rekreacion.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* third section */}
      <div className='w-[80%] mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='lg:pr-10 w-full lg:w-[90%] flex flex-col items-start lg:items-end'>
              <h1 className=' montserrat text-white  opacity-50 font-extralight text-4xl lg:text-7xl'>03. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5  text-left lg:text-right'>QENDER
                <br />
                <span className='main-red-color'>FITNESI</span></h1>
              <p className='text-white montserrat text-base lg:text-xl  mt-5 lg:text-right'>
                Me nje qender komuniteti te mireorganizuar dhe nje qender fitnesi te pajisur ne menyre moderne, banoret kan gjithcka
                qe ju nevojitet per te zhvilluar nje jete aktive dhe te mbushur me energji pozitive.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <img src="/images/services/fitness.png" className='lg:h-[80vh] object-cover rounded-[10px]' alt="" />
          </div>
        </div>
      </div>


      {/* fourth section */}
      <div className='w-[80%] mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 order-2 lg:order-1 lg:col-span-7">
            <img src="/images/services/smart-homes.png" className='lg:h-[80vh] object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5 order-1 lg:order-2   flex flex-col relative">
            <div className='w-full lg:w-[80%]'>
              <h1 className='lg:pl-10 montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>04. </h1>
              <h1 className='lg:pl-10 text-white tex-regular text-5xl lg:text-7xl mt-5'>SISTEMI
                <br />
                <span className='main-red-color'>SMART</span></h1>
              <p className='text-white montserrat lg:pl-10 text-base lg:text-xl  '>
                Sistemi SMART HOME ofron kontroll te plote te hapesires tuaj, duke kombinuar komoditetin, sigurine dhe kursimin e energjise
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* fourth section */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 order-2 lg:order-1 lg:col-span-7">
            <img src="/images/services/vacumm.png" className=' object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5  order-1 lg:order-2 flex flex-col relative">
            <div className='w-full lg:w-[80%] lg:pl-10'>
              <h1 className=' montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>05. </h1>
              <h1 className=' text-white tex-regular  text-5xl lg:text-7xl mt-5'>FSHESA ME
                <br />
                <span className='main-red-color'>VAKUM</span></h1>
              <p className='text-white montserrat text-base lg:text-xl  mt-5 lg:mt-10'>
                Banoret e kompleksit HIT IMPERIAL do te kene ne dispozicion nje sistem te integruar
                te fsheses qendrore me vakum ne cdo apartament.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* sixth section */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='w-full lg:w-[80%] lg:pr-10 flex flex-col lg:items-end'>
              <h1 className='montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>06. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5 lg:text-right'>NGORHJE
                <br />
                <span className='main-red-color'>TERMIKE</span></h1>
              <p className='text-white montserrat text-base  lg:text-xl mt-5 lg:mt-10 lg:text-right'>
                Ne kompleksin HIT IMPERIAL, cdo apartament eshte i pajisur me nje sistem te avancuar te pompes termike,
                i cili garanton ngrohje dhe ftohje te qendrueshme gjate gjithe vitit.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <div className='lg:h-[80vh] main-green-bg rounded-[10px] flex center'>
              <img src="/images/cut-images/heat-pump.png" className='h-[70%] object-cover ' alt="" />
            </div>
          </div>
        </div>
      </div>

      {/* seventh section */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-7 order-2 lg:order-1">
            <img src="/images/services/living-room.png" className=' object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5 order-1 lg:order-2  flex flex-col relative">
            <div className='flex-flex-col w-full lg:w-[80%] lg:pl-10'>
              <h1 className=' montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>07. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5'> DHOMAT E
                <br />
                <span className='main-red-color'>NDENJES</span></h1>
              <p className='text-white montserrat text-base lg:text-xl mt-5 lg:mt-10'>
                Cdo hapesire eshte dizajnuar per te maksimizuar ndricimin natyral, ajrosjne dhe komoditetin, ndersa
                materialet e zgjedhura garantojne cilesi dhe qendrueshmeri afatgjate.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* eigth */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='w-full lg:w-[80%] lg:pr-10 flex flex-col lg:items-end'>
              <h1 className='montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>08. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5 lg:text-right'>KUZHINA
                <br />
                {/* <span className='main-red-color'>TERMIKE</span> */}
              </h1>
              <p className='text-white montserrat text-base  lg:text-xl mt-5 lg:mt-10 lg:text-right'>
                Linja te pastra, hapesira te bollshme dhe organizim inteligjent. Pamje moderne dhe materiale premium.
                Ndricim i balancuar, qasje e lehte nga hyrja dhe ergonomi e avancuar.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <img src="/images/services/kitchen.png" className='lg:h-[80vh] rounded-[10px] object-cover ' alt="" />
          </div>
        </div>
      </div>

      {/* masterbedroom */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-7 order-2 lg:order-1">
            <img src="/images/services/master-bedroom.png" className=' object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5 order-1 lg:order-2  flex flex-col relative">
            <div className='flex-flex-col w-full lg:w-[80%] lg:pl-10'>
              <h1 className=' montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>09. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5'> MASTER
                <br />
                <span className='main-red-color'>DHOMA</span></h1>
              <p className='text-white montserrat text-base lg:text-xl mt-5 lg:mt-10'>
                Me dizjanin a zgjuar, ndricimin natyral dhe hapesirat e organizuara, dhomat
                e prinderve ne HIT IMPERIAL, jane nje perzierje perfekte mes stilit modern dhe funksionalitetit te larte.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* kids bedroom */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='w-full lg:w-[80%] lg:pr-10 flex flex-col lg:items-end'>
              <h1 className='montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>10. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5 lg:text-right'>DHOMA
                <br />
                <span className='main-red-color'>E FEMIJEVE</span>
              </h1>
              <p className='text-white montserrat text-base  lg:text-xl mt-5 lg:mt-10 lg:text-right'>
                Me ndricim natyral, hapesira per kreativitet dhe nje organizim modern, dhoma e femijeve ne HIT IMPERIAL
                eshte nje mjedis i persosur per te nxitur zhvillimin, imagjinaten dhe rehatine e femijeve tuaj.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <img src="/images/services/children-bedroom.png" className='lg:h-[80vh] rounded-[10px] object-cover ' alt="" />
          </div>
        </div>
      </div>


      {/* greenland */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-7 order-2 lg:order-1">
            <img src="/images/services/greenlands.png" className=' object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5 order-1 lg:order-2  flex flex-col relative">
            <div className='flex-flex-col w-full lg:w-[80%] lg:pl-10'>
              <h1 className=' montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-6xl'>10. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-6xl mt-5'> HAPESIRA
                <span className='main-red-color'> TE GJELBERUARA</span></h1>
              <p className='text-white montserrat text-base lg:text-xl mt-5 lg:mt-10'>
                HIT IMPERIAL shtrihet mbi 10,000 m2 hapesira te gjelberuara, te menduara per te krijuaj nje
                ekosistem te shendetshem dhe nje menyre jetese harmonike.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* kids playground */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='w-full lg:w-[80%] lg:pr-10 flex flex-col lg:items-end'>
              <h1 className='montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>11. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5 lg:text-right'>KENDI
                <br />
                <span className='main-red-color'>LOJRAVE</span>
              </h1>
              <p className='text-white montserrat text-base  lg:text-xl mt-5 lg:mt-10 lg:text-right'>
                Brenda kompleksit ndodhet nje kend i dedikuar per lojera dhe nje kopsht per femije,
                duke ofruar nje mjedis te sigurt dhe te pasur per zhvillimin e tyre.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <img src="/images/services/playground.png" className='lg:h-[80vh] w-full rounded-[10px] object-cover ' alt="" />
          </div>
        </div>
      </div>


      {/* invest */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-7 order-2 lg:order-1">
            <img src="/images/services/investments.png" className=' object-cover rounded-[10px]' alt="" />
          </div>
          <div className="col-span-12 lg:col-span-5 order-1 lg:order-2  flex flex-col relative">
            <div className='flex-flex-col w-full lg:w-[80%] lg:pl-10'>
              <h1 className=' montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-6xl'>12. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-6xl mt-5'> INVSETIME
                <span className='main-red-color'> STRATEGJIKE</span></h1>
              <p className='text-white montserrat text-base lg:text-xl mt-5 lg:mt-10'>
                Ne HIT IMPERIAL, ju keni mundesine te beheni pjese e nje kompleksi modern,
                duke investuar ne apartamente te standartit te larte ose ne hapersia afariste.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* parking */}
      <div className='w-[80%] lg:w-full mt-20 lg:mt-40'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 lg:col-span-5 flex flex-col relative items-end">
            <div className='w-full lg:w-[80%] lg:pr-10 flex flex-col lg:items-end'>
              <h1 className='montserrat text-white left-5 opacity-50 font-extralight text-4xl lg:text-7xl'>13. </h1>
              <h1 className=' text-white tex-regular text-5xl lg:text-7xl mt-5 lg:text-right'>PARKINGU
                <br />
                {/* <span className='main-red-color'>LOJRAVE</span> */}
              </h1>
              <p className='text-white montserrat text-base  lg:text-xl mt-5 lg:mt-10 lg:text-right'>
                Me nje organizim te mirestrukturuar, parkingjet jane te ndara ne 3 nivele per te optimizuar
                hapesiren dhe per te shmangur mbipopullimin.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <img src="/images/services/e-parking.jpg" className='lg:h-[80vh]  w-full rounded-[10px] object-cover ' alt="" />
          </div>
        </div>
      </div>


    </div>
  )

}

export default Index